import { useAuth } from '../authContext';
import TabulatorExample from '../TabulatorExample';
export default function Dashboard() {
  const { user } = useAuth();
  return user ? <div><h1>Welcome, {user.email}</h1> <div><TabulatorExample /></div></div>: <p>Loading...</p>;
}
